"use strict";
/*
* This is a customised version of https://github.com/dotnet/aspnetcore/blob/main/src/Components/WebAssembly/WebAssembly.Authentication/src/Interop/AuthenticationService.ts (At the time of writing, the latest version of it came from this commit: https://github.com/dotnet/aspnetcore/tree/42928bdb1eb385d0360c16d7026b57e9d1ef0db3)
* The docs support this: https://learn.microsoft.com/en-us/aspnet/core/blazor/security/webassembly/additional-scenarios?view=aspnetcore-8.0#replace-any-javascript-authenticationservice-implementation
* I took Microsoft's implementation and modified it slightly to support passing the authority on a per-request basis.
* This allows us to use different AAD B2C sign in/sign up policies. By default, Blazor only supports using one
* sign in/sign up policy, which is defined in your Program.cs.
*
*
* I also changed `...interactiveRequest.additionalRequestParameters` to `extraQueryParameters: interactiveRequest.additionalRequestParameters`
* so that i can pass params through to the AAD B2C authorize URL. There was probably a way to do this without changing
* the code below, but changing the code was easier.
*
* **Ongoing maintenance**: You should check for changes to this file in the upstream repo linked above.
* */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationService = exports.Logger = exports.LogLevel = void 0;
var Msal = require("@azure/msal-browser");
var AccessTokenResultStatus;
(function (AccessTokenResultStatus) {
    AccessTokenResultStatus["Success"] = "success";
    AccessTokenResultStatus["RequiresRedirect"] = "requiresRedirect";
})(AccessTokenResultStatus || (AccessTokenResultStatus = {}));
var AuthenticationResultStatus;
(function (AuthenticationResultStatus) {
    AuthenticationResultStatus["Redirect"] = "redirect";
    AuthenticationResultStatus["Success"] = "success";
    AuthenticationResultStatus["Failure"] = "failure";
    AuthenticationResultStatus["OperationCompleted"] = "operationCompleted";
})(AuthenticationResultStatus || (AuthenticationResultStatus = {}));
// These are the values for the .NET logger LogLevel.
// We only use debug and trace
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
var Logger = /** @class */ (function () {
    function Logger(options) {
        this.debug = options.debugEnabled;
        this.trace = options.traceEnabled;
    }
    Logger.prototype.log = function (level, message) {
        if ((level == LogLevel.Trace && this.trace) ||
            (level == LogLevel.Debug && this.debug)) {
            var levelString = level == LogLevel.Trace ? 'trce' : 'dbug';
            console.debug(
            // Logs in the following format to keep consistency with the way ASP.NET Core logs to the console while avoiding the
            // additional overhead of passing the logger as a JSObjectReference
            // dbug: Microsoft.AspNetCore.Components.WebAssembly.Authentication.RemoteAuthenticationService[0]
            //       <<message>>
            // trce: Microsoft.AspNetCore.Components.WebAssembly.Authentication.RemoteAuthenticationService[0]
            //       <<message>>
            "".concat(levelString, ": Microsoft.AspNetCore.Components.WebAssembly.Authentication.RemoteAuthenticationService[0]\n      ").concat(message));
        }
    };
    return Logger;
}());
exports.Logger = Logger;
;
var MsalAuthorizeService = /** @class */ (function () {
    function MsalAuthorizeService(_settings, _logger) {
        var _a, _b;
        this._settings = _settings;
        this._logger = _logger;
        if (((_b = (_a = this._settings.auth) === null || _a === void 0 ? void 0 : _a.knownAuthorities) === null || _b === void 0 ? void 0 : _b.length) == 0) {
            this._settings.auth.knownAuthorities = [new URL(this._settings.auth.authority).hostname];
        }
        this._settings.system = this._settings.system || {};
        this._settings.system.navigationClient = {
            navigateInternal: function (url, options) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        // We always replace the URL
                        _logger.log(LogLevel.Trace, "Navigating to ".concat(url));
                        location.replace(url);
                        return [2 /*return*/, false];
                    });
                });
            },
            navigateExternal: function (url, options) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        // We always replace the URL
                        _logger.log(LogLevel.Trace, "Navigating to ".concat(url));
                        location.replace(url);
                        return [2 /*return*/, false];
                    });
                });
            }
        };
        this._settings.system.loggerOptions = {
            logLevel: _logger.trace ? Msal.LogLevel.Trace : (_logger.debug ? Msal.LogLevel.Verbose : Msal.LogLevel.Warning),
            loggerCallback: function (level, message, containsPii) {
                if (containsPii) {
                    return;
                }
                if (level === Msal.LogLevel.Trace) {
                    _logger.log(LogLevel.Trace, message);
                    return;
                }
                // We only have Debug/Trace, so anything above, we only log when Debug is enabled.
                _logger.log(LogLevel.Debug, message);
                return;
            }
        };
        this._msalApplication = new Msal.PublicClientApplication(this._settings);
    }
    MsalAuthorizeService.prototype.getAccount = function () {
        if (this._account) {
            return this._account;
        }
        var accounts = this._msalApplication.getAllAccounts();
        if (accounts && accounts.length) {
            return accounts[0];
        }
        return null;
    };
    MsalAuthorizeService.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                account = this.getAccount();
                if (!account) {
                    return [2 /*return*/];
                }
                return [2 /*return*/, account.idTokenClaims];
            });
        });
    };
    MsalAuthorizeService.prototype.getAccessToken = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var newToken, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.trace('getAccessToken', request);
                        return [4 /*yield*/, this.getTokenCore(request === null || request === void 0 ? void 0 : request.scopes)];
                    case 1:
                        newToken = _a.sent();
                        return [2 /*return*/, {
                                status: AccessTokenResultStatus.Success,
                                token: newToken
                            }];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, {
                                status: AccessTokenResultStatus.RequiresRedirect
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.getTokenCore = function (scopes) {
        return __awaiter(this, void 0, void 0, function () {
            var account, silentRequest, response, result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        account = this.getAccount();
                        if (!account) {
                            throw new Error('Failed to retrieve token, no account found.');
                        }
                        silentRequest = {
                            redirectUri: (_a = this._settings.auth) === null || _a === void 0 ? void 0 : _a.redirectUri,
                            account: account,
                            scopes: scopes || this._settings.defaultAccessTokenScopes
                        };
                        this.debug("Provisioning a token silently for scopes '".concat(silentRequest.scopes, "'"));
                        this.trace('_msalApplication.acquireTokenSilent', silentRequest);
                        return [4 /*yield*/, this._msalApplication.acquireTokenSilent(silentRequest)];
                    case 1:
                        response = _b.sent();
                        this.trace('_msalApplication.acquireTokenSilent-response', response);
                        if (response.scopes.length === 0 || response.accessToken === '') {
                            throw new Error('Scopes not granted.');
                        }
                        result = {
                            value: response.accessToken,
                            grantedScopes: response.scopes,
                            expires: response.expiresOn
                        };
                        this.trace('getAccessToken-result', result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.signIn = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var state, interactiveRequest, request, request, result, e_2, message;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.trace('signIn', context);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        // Before we start any sign-in flow, clear out any previous state so that it doesn't pile up.
                        this.purgeState();
                        state = context.state, interactiveRequest = context.interactiveRequest;
                        if (!(interactiveRequest && interactiveRequest.interaction === 'GetToken')) return [3 /*break*/, 3];
                        this.debug('Acquiring additional token.');
                        request = {
                            scopes: interactiveRequest.scopes || [],
                            state: this.saveState(context.state),
                            extraQueryParameters: interactiveRequest.additionalRequestParameters
                        };
                        this.trace('getInteractiveToken-Request', request);
                        return [4 /*yield*/, this._msalApplication.acquireTokenRedirect(request)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, this.success(state)];
                    case 3:
                        request = {
                            redirectUri: this._settings.auth.redirectUri,
                            state: this.saveState(context.state),
                            extraQueryParameters: interactiveRequest === null || interactiveRequest === void 0 ? void 0 : interactiveRequest.additionalRequestParameters
                        };
                        if (((_a = context.state) === null || _a === void 0 ? void 0 : _a.authority) != null) {
                            request.authority = context.state.authority;
                        }
                        request.scopes = request.scopes || this._settings.defaultAccessTokenScopes || [];
                        return [4 /*yield*/, this.signInCore(request)];
                    case 4:
                        result = _b.sent();
                        this.trace('signIn-Response', result);
                        if (!result) {
                            return [2 /*return*/, this.redirect()];
                        }
                        else if (this.isMsalError(result)) {
                            return [2 /*return*/, this.error(result.errorMessage)];
                        }
                        return [2 /*return*/, this.success(state)];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_2 = _b.sent();
                        message = e_2.message;
                        this.debug("Sign in error '".concat(message, "'"));
                        return [2 /*return*/, this.error(message)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.signInCore = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var loginMode;
            return __generator(this, function (_a) {
                this.trace('signIn-Request', request);
                loginMode = this._settings.loginMode.toLowerCase();
                if (loginMode === 'redirect') {
                    return [2 /*return*/, this.signInWithRedirect(request)];
                }
                else {
                    return [2 /*return*/, this.signInWithPopup(request)];
                }
                return [2 /*return*/];
            });
        });
    };
    MsalAuthorizeService.prototype.signInWithRedirect = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.debug('Starting sign-in redirect.');
                        return [4 /*yield*/, this._msalApplication.loginRedirect(request)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        this.debug("Sign-in redirect failed: '".concat(e_3.message, "'."));
                        return [2 /*return*/, e_3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.signInWithPopup = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.debug('Starting sign-in pop-up');
                        return [4 /*yield*/, this._msalApplication.loginPopup(request)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_4 = _a.sent();
                        // If the user explicitly cancelled the pop-up, avoid performing a redirect.
                        if (this.isMsalError(e_4) && e_4.errorCode !== Msal.BrowserAuthErrorMessage.userCancelledError.code) {
                            this.debug('User canceled sign-in pop-up');
                            this.signInWithRedirect(request);
                        }
                        else {
                            this.debug("Sign-in pop-up failed: '".concat(e_4.message, "'."));
                            return [2 /*return*/, e_4];
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.completeSignIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authenticationResult, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.debug('Completing sign-in redirect.');
                        return [4 /*yield*/, this._redirectCallback];
                    case 1:
                        authenticationResult = _a.sent();
                        this.trace('completeSignIn-result', authenticationResult);
                        if (authenticationResult) {
                            this.trace('completeSignIn-success', authenticationResult);
                            return [2 /*return*/, authenticationResult];
                        }
                        this.debug('No authentication result.');
                        return [2 /*return*/, this.operationCompleted()];
                    case 2:
                        e_5 = _a.sent();
                        this.debug("completeSignIn-error:'".concat(e_5.message, "'"));
                        return [2 /*return*/, this.error(e_5.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.signOut = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var state, interactiveRequest, request, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.trace('signOut', context);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // Before we start any sign-in flow, clear out any previous state so that it doesn't pile up.
                        this.purgeState();
                        state = context.state, interactiveRequest = context.interactiveRequest;
                        request = __assign({ postLogoutRedirectUri: this._settings.auth.postLogoutRedirectUri, state: this.saveState(state) }, interactiveRequest === null || interactiveRequest === void 0 ? void 0 : interactiveRequest.additionalRequestParameters);
                        this.trace('signOut-Request', request);
                        return [4 /*yield*/, this._msalApplication.logoutRedirect(request)];
                    case 2:
                        _a.sent();
                        // We are about to be redirected.
                        return [2 /*return*/, this.redirect()];
                    case 3:
                        e_6 = _a.sent();
                        return [2 /*return*/, this.error(e_6.message)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.completeSignOut = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var authenticationResult, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.trace('completeSignOut-request', url);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.debug('Completing sign-out redirect.');
                        return [4 /*yield*/, this._redirectCallback];
                    case 2:
                        authenticationResult = _a.sent();
                        this.trace('completeSignOut-result', authenticationResult);
                        if (authenticationResult) {
                            this.trace('completeSignOut-success', authenticationResult);
                            return [2 /*return*/, authenticationResult];
                        }
                        this.debug('No authentication result.');
                        return [2 /*return*/, this.operationCompleted()];
                    case 3:
                        e_7 = _a.sent();
                        this.debug("completeSignOut-error:'".concat(e_7.message, "'"));
                        return [2 /*return*/, this.error(e_7.message)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // msal.js only allows a string as the account state and it simply attaches it to the sign-in request state.
    // Given that we don't want to serialize the entire state and put it in the query string, we need to serialize the
    // state ourselves and pass an identifier to retrieve it while in the callback flow.
    MsalAuthorizeService.prototype.saveState = function (state) {
        var identifier = window.crypto.randomUUID();
        sessionStorage.setItem("".concat(AuthenticationService._infrastructureKey, ".AuthorizeService.").concat(identifier), JSON.stringify(state));
        return identifier;
    };
    MsalAuthorizeService.prototype.retrieveState = function (url, providedState, isLogout) {
        if (providedState === void 0) { providedState = null; }
        if (isLogout === void 0) { isLogout = false; }
        var stateFromUrl;
        // Parse the state key from the `search` query parameter in the URL if provided
        if (url) {
            var parsedUrl = new URL(url);
            stateFromUrl = parsedUrl.searchParams && parsedUrl.searchParams.getAll('state');
        }
        // Chose  the provided state from MSAL. Otherwise, choose the state computed from the URL
        var state = providedState || stateFromUrl;
        if (!state) {
            return undefined;
        }
        var stateKey = "".concat(AuthenticationService._infrastructureKey, ".AuthorizeService.").concat(state);
        var stateString = sessionStorage.getItem(stateKey);
        if (stateString) {
            sessionStorage.removeItem(stateKey);
            var savedState = JSON.parse(stateString);
            return savedState;
        }
        return undefined;
    };
    MsalAuthorizeService.prototype.purgeState = function () {
        for (var i = 0; i < sessionStorage.length; i++) {
            var key = sessionStorage.key(i);
            if (key === null || key === void 0 ? void 0 : key.startsWith(AuthenticationService._infrastructureKey)) {
                sessionStorage.removeItem(key);
            }
        }
    };
    MsalAuthorizeService.prototype.initializeMsalHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._redirectCallback = this.completeAuthentication();
                        return [4 /*yield*/, this._msalApplication.initialize()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.completeAuthentication = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._msalApplication.initialize()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this._msalApplication.handleRedirectPromise()];
                    case 3:
                        result = _a.sent();
                        res = this.handleResult(result);
                        return [2 /*return*/, res];
                    case 4:
                        error_1 = _a.sent();
                        if (this.isMsalError(error_1)) {
                            return [2 /*return*/, this.error(error_1.errorMessage)];
                        }
                        else {
                            return [2 /*return*/, this.error(error_1.message)];
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        ;
                        return [2 /*return*/];
                }
            });
        });
    };
    MsalAuthorizeService.prototype.handleResult = function (result) {
        var logoutState = this.retrieveState(location.href, undefined);
        if (result) {
            this._account = result.account;
            return this.success(this.retrieveState(null, result.state));
        }
        else if (logoutState) {
            return this.success(logoutState);
        }
        else {
            return this.operationCompleted();
        }
    };
    MsalAuthorizeService.prototype.isMsalError = function (resultOrError) {
        return resultOrError === null || resultOrError === void 0 ? void 0 : resultOrError.errorCode;
    };
    MsalAuthorizeService.prototype.error = function (message) {
        return { status: AuthenticationResultStatus.Failure, errorMessage: message };
    };
    MsalAuthorizeService.prototype.success = function (state) {
        return { status: AuthenticationResultStatus.Success, state: state };
    };
    MsalAuthorizeService.prototype.redirect = function () {
        return { status: AuthenticationResultStatus.Redirect };
    };
    MsalAuthorizeService.prototype.operationCompleted = function () {
        return { status: AuthenticationResultStatus.OperationCompleted };
    };
    MsalAuthorizeService.prototype.debug = function (message) {
        var _a;
        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.log(LogLevel.Debug, message);
    };
    MsalAuthorizeService.prototype.trace = function (message, data) {
        var _a;
        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.log(LogLevel.Trace, "".concat(message, ": ").concat(JSON.stringify(data)));
    };
    return MsalAuthorizeService;
}());
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService() {
    }
    AuthenticationService.init = function (settings, jsLoggingOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!AuthenticationService._initialized) return [3 /*break*/, 2];
                        AuthenticationService.instance = new MsalAuthorizeService(settings, new Logger(jsLoggingOptions));
                        return [4 /*yield*/, AuthenticationService.instance.initializeMsalHandler()];
                    case 1:
                        _a.sent();
                        AuthenticationService._initialized = true;
                        _a.label = 2;
                    case 2: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    AuthenticationService.getUser = function () {
        return AuthenticationService.instance.getUser();
    };
    AuthenticationService.getAccessToken = function (request) {
        return AuthenticationService.instance.getAccessToken(request);
    };
    AuthenticationService.signIn = function (state) {
        return AuthenticationService.instance.signIn(state);
    };
    // url is not used in the msal.js implementation but we keep it here
    // as it is part of the default RemoteAuthenticationService contract implementation.
    // The unused parameter here just reflects that.
    AuthenticationService.completeSignIn = function (url) {
        return AuthenticationService.instance.completeSignIn();
    };
    AuthenticationService.signOut = function (state) {
        return AuthenticationService.instance.signOut(state);
    };
    AuthenticationService.completeSignOut = function (url) {
        return AuthenticationService.instance.completeSignOut(url);
    };
    AuthenticationService._infrastructureKey = 'Microsoft.Authentication.WebAssembly.Msal';
    return AuthenticationService;
}());
exports.AuthenticationService = AuthenticationService;
